/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'avi-forms';
const componentName = 'avi-repeated-collection-or-custom-value';
const prefix = `${moduleName}.${componentName}`;

export const addItemButtonLabel = `${prefix}.addItemButtonLabel`;

export const ENGLISH = {
    [addItemButtonLabel]: 'Add Item',
};
